import { useForm } from "react-hook-form";
//@ts-ignore
import { FormLayout } from "@careinfo/layout";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import { ICreateTagsData } from "./CreateTag";
import EditTagForm from "./TagForm";
import CreateIcon from "../../Icons/CreateIcon";
import { createTagSchema, ITagSchema } from "../../utils/validationSchema";
import APIS from "../../constant/Endpoint";
import useGetHook from "../../customHooks/useGetHook";
import Spinner from "../Reusable/Spinner";
import { yupResolver } from "@hookform/resolvers/yup";

const EditTag = (props: any) => {
  const { handleEdit, isLoading, data } = props;

  const {
    register,
    handleSubmit,
    getValues,
    setError,
    setValue,
    clearErrors,
    control,
    formState: { errors },
  } = useForm<ITagSchema>({
    defaultValues: async () => ({
      name: data?.name,
      preview_image: data?.preview_image,
      description: data?.description,
    }),
    resolver: yupResolver(createTagSchema),
  });

  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center`}
      >
        <CreateIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>Edit Tag</span>
      </div>
      <FormLayout
        handleSubmit={handleSubmit}
        handleFormSubmit={handleEdit}
        setError={setError}
        buttonLabel={"Update"}
        isLoading={isLoading}
      >
        <EditTagForm
          errors={errors}
          register={register}
          setValue={setValue}
          getValues={getValues}
          clearErrors={clearErrors}
          control={control}
        />
      </FormLayout>
    </>
  );
};

export default EditTag;
